import React from "react";
import { Link } from "react-router-dom";
import EbayReviewsCarousel from "../reviews/EbayReviewsCarousel";
import { EBAY_POSITIVE_COUNT, getFeaturedEbayReviews } from "../../lib/ebayReviews";
import { HOME_CTA_DARK_OUTLINE } from "../../lib/homeCta";

/** Marketplace feedback — emotional, trustworthy, not oversized. */
export default function HomeReviewsTeaser() {
  const featured = getFeaturedEbayReviews(8);
  const hasReviews = featured.length > 0;

  return (
    <section
      id="marketplace-feedback"
      className="relative py-9 md:py-11 scroll-mt-24 bg-panel"
      aria-labelledby="home-proof-heading"
    >
      <div className="relative max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center mb-6 md:mb-7">
          <h2
            id="home-proof-heading"
            className="font-sans font-semibold text-2xl md:text-3xl text-ivory m-0 leading-snug tracking-tight"
          >
            Real feedback from earlier customers
          </h2>
          <p className="mt-3 text-[15px] md:text-base text-sage leading-relaxed m-0 max-w-xl mx-auto">
            Before MossMatrix.com, customers found us through marketplace orders. We’re bringing that same direct
            experience here.
          </p>
          {hasReviews ? (
            <p className="mt-2 text-sm text-gold/90 m-0">
              Positive eBay buyer quotes · {EBAY_POSITIVE_COUNT.toLocaleString("en-GB")} positive in the last 12 months
            </p>
          ) : null}
        </div>

        {hasReviews ? (
          <>
            <EbayReviewsCarousel mode="teaser" showSourceNote={false} featuredSize />
            <div className="mt-6 flex justify-center">
              <Link to="/reviews" className={`${HOME_CTA_DARK_OUTLINE} min-h-[44px] px-6 py-2.5`}>
                Browse all feedback
              </Link>
            </div>
          </>
        ) : (
          <div className="rounded-2xl border border-[rgba(248,241,223,0.14)] bg-[color:var(--mm-panel-warm)] px-6 py-7 text-center">
            <p className="text-[15px] text-sage m-0 leading-relaxed">
              Customer feedback from our eBay shop will appear here soon.
            </p>
            <Link to="/reviews" className={`${HOME_CTA_DARK_OUTLINE} mt-5 min-h-[44px] px-6 py-2.5 inline-flex`}>
              Visit reviews
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
